import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Product, Category, Paging , CategoryResponse, Tag, CategoryItems} from '../../products/product';
import { ProductsService } from '../../products/products.service';
import { FavoritesService } from '../../products/favorites.service';
import { Query } from '../../products/query';
import { ConfigurationService } from '../../configuration.service';
import { Configuration } from '../../configuration';
import { ControlsService } from '../../controls.service';

import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { map, switchMap, publish, tap, take, filter } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { takeWhile } from 'rxjs/operators';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ResolveStart,
  ResolveEnd
} from "@angular/router";


@Component({
  selector: "app-products-categories",
  templateUrl: "./products-categories.component.html",
  styleUrls: ["./products-categories.component.scss"]
})
export class ProductsCategoriesComponent implements OnInit {
  topLevelCategories: Category[];
  latestPaid: Product[];
  latestFree: Product[];
  favorites: Product[];
  latestItems: CategoryItems[];
  recentDownloads: Product[];
  config: Configuration;
  dataLoading: boolean = true;

  @Input()
  currentCategory: Category;

  constructor(
    private productsService: ProductsService,
    private favoritesService: FavoritesService,
    private configurationService: ConfigurationService,
    private cs: ControlsService,
    private router: Router
  ) {
    this.config = configurationService.getConfigurationCache();
  }


  ngOnInit() {
    var catSort = 0;
    var currentCat = 0;
               this.router.events.subscribe(val => {
                 // if navigation event has started
                 if (val instanceof NavigationStart) {
                   this.dataLoading = true;
                 }
                 // if navigation has resolved
                 if (val instanceof ResolveEnd) {
                   this.dataLoading = false;
                 }
               });

               this.configurationService
                 .getConfigurationSubject()
                 .subscribe((config: Configuration) => {
                   if (config.license) this.config = config;
                 });

                const filterObj: Query = {recent: true, limit: 500};

                  this.productsService.getProducts(filterObj)
                  .pipe(map(items => {
                     return items.data.reduce((groups, n) => {
                       const mainCat: any = n.category[0];
                       if (mainCat != undefined) {
                         let key = mainCat.id;

                          if (currentCat != key) {
                            catSort++;
                            currentCat = key;
                          }

                         const objectProxy: CategoryItems = { items: [] };

                         (groups[key] = groups[key] || objectProxy).items.push(n);
                         groups[key] = Object.assign({ id: key, category_name: mainCat.category_name, title: mainCat.title, group_id: mainCat.group_id, uploadDate: catSort }, groups[key]);

                         return groups;
                       } else {
                         console.log(n.id + " missing category");
                         return [];
                       }
                     }, {});
                   }), map(item => {
                     return Object.keys(item).map(i => item[i]);
                   }) )
                 .subscribe((results: CategoryItems[]) => {
                     this.dataLoading = false;
                     this.latestItems = results;
                   }, err => console.error(err), () => console.log("done loading latest Items"));

               // this.productsService.getCatoriesTopLevel()
               //   .subscribe(data => {
               //     this.topLevelCategories = data;
               //     this.dataLoading = false;
               //   });

               this.favoritesService
                 .getFavoritesSubject()
                 .subscribe(
                   (results: Product[]) => {
                     this.favorites = results;
                   },
                   err => console.error(err),
                   () => console.log("done loading favorites")
                 );

               // this.favoritesService.getRecentDownloadSubject().subscribe(
               //   (results: Product[]) => {
               //     this.recentDownloads = results;
               //   },
               //   err => console.error(err),
               //   () => console.log("done loading favorites")
               // );
             }
}//init



// WEBPACK FOOTER //
// ./src/app/home-page/products-categories/products-categories.component.ts